import { render, staticRenderFns } from "./ProviderCreate.vue?vue&type=template&id=72b36624"
import script from "./ProviderCreate.vue?vue&type=script&lang=js"
export * from "./ProviderCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports